/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_PhoneInputs */

const en__field_phone = /** @type {(inputs: _Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Phone Number`)
};

const de__field_phone = /** @type {(inputs: _Field_PhoneInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Telefonnummer`)
};

/**
* | output |
* | --- |
* | "Phone Number" |
*
* @param {_Field_PhoneInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const _field_phone = /** @type {((inputs?: _Field_PhoneInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_PhoneInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_phone(inputs)
	return de__field_phone(inputs)
});